// Module
var code = "<div class=\"ui-grid-cell-contents\">{{row.entity.ExpirationDate | date : \"shortDate\"}}</div>\n";
// Exports
module.exports = code;